import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Pagination from 'react-paginate';
import RightIcon from '@material-ui/icons/ChevronRight';
import LeftIcon from '@material-ui/icons/ChevronLeft';
import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  pageInfo: {
    marginRight: theme.spacing(1),
    fontSize: '12px',
    lineHeight: '16px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  pagination: {
    marginLeft: 'auto',
    display: 'flex',
    '& a': {
      border: `1px solid ${theme.palette.xpl.stoke}`,
      marginLeft: -1,
      padding: '7px 12px',
      textAlign: 'center',
      display: 'block',
      height: '32px',
      width: 'auto',
      fontSize: '12px',
      lineHeight: '16px',
      color: theme.palette.xpl.text.primary,
      backgroundColor: theme.palette.xpl.foreground,
    },
    '& li:first-child a': {
      padding: 0,
      borderRadius: `100px 0px 0px 100px`,
    },
    '& li:first-child .MuiTouchRipple-root': {
      marginTop: '1.5px',
      borderRadius: `100px 0px 0px 100px`,
    },
    '& li:first-child button': {
      padding: '3px 4px 2px 4px',
    },
    '& li:last-child a': {
      padding: 0,
      borderRadius: `0px 100px 100px 0px`,
    },
    '& li:last-child .MuiTouchRipple-root': {
      marginTop: '1.5px',
      borderRadius: `0px 100px 100px 0px`,
    },
    '& li:last-child button': {
      padding: '3px 4px 2px 4px',
    },
    '& li.break': {
      fontWeight: 'bold',
    },
    '& li.active a': {
      backgroundColor: theme.palette.xpl.secondary.background,
      borderColor: theme.palette.xpl.stoke,
      color: theme.palette.xpl.text.primary,
    },
  },
  paginationList: {},
});
const TablePagination = (props) => {
  const {
    classes,
    className,
    dataCount,
    onPageChange,
    rowsPerPage,
    currentPage,
    pageCount,
  } = props;

  // const pageCount = Math.ceil(dataCount / rowsPerPage);
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.pageInfo}>
        Viewing{' '}
        <b>
          {currentPage * rowsPerPage + 1}-
          {Math.min(currentPage * rowsPerPage + rowsPerPage, dataCount)}
        </b>{' '}
        of <b>{dataCount}</b>
      </div>
      <Pagination
        containerClassName={classes.pagination}
        previousLabel={
          <ButtonBase>
            <LeftIcon />
          </ButtonBase>
        }
        nextLabel={
          <ButtonBase>
            <RightIcon />
          </ButtonBase>
        }
        //  breakLabel={null}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={4}
        onPageChange={onPageChange}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        forcePage={currentPage}
      />
    </div>
  );
};

TablePagination.propTypes = {
  classes: PropTypes.object.isRequired,
  dataCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  className: PropTypes.string,
};

export default withStyles(styles)(TablePagination);
